import React from "react";
import trans from "../../../utils";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";

export default function CustomerExtra({ values = {} }) {
	const getValue = (val) => {
		if (val === true) {
			return trans("on");
		} else if (val === false) {
			return trans("off");
		} else {
			return val;
		}
	};
	return (
		<div>
			{values?.customAttributes?.length > 0 && (
				<div className="row">
					<div className="col-lg-12">
						<p className="fs-16 fw-500 brand-700 text-uppercase">
							{trans("Custom Attributes")}
						</p>
						{values?.customAttributes?.map((i, index) => (
							<div key={index} className="display-border">
								<PopupBodyItem title={i?.name} item={getValue(i?.value)} />
							</div>
						))}
					</div>
				</div>
			)}
			{values?.customAttributes?.length === 0 && (
				<div
					className="d-flex align-items-center justify-content-center"
					style={{ height: "300px" }}
				>
					{trans("No data")}
				</div>
			)}
		</div>
	);
}
